module.exports = __webpack_public_path__ + "static/media/etil.2b9c393a.png";